module.exports = __webpack_public_path__ + "img/Arrow1.6898e7f0.svg";